<style scoped>
  .numero {  height: 50px;  }
  .p-t-10 { padding-top: 10px}
</style>

<template>
  <portal-box class="has-text-centered">

    <div class="numero">
      <portal-loading-small class="p-h-sm" :loading="loading" />

      <div v-if="!loading" class="animated fadeIn">
        <div class="is-size-4 p-t-10" v-if="valor"> {{ valor | moeda }} </div>
        <div class="is-size-2" v-else> - </div>
      </div>
    </div>

    <p> {{ texto }} </p>
  </portal-box>
</template>
<script>
  export default {
    props: ['valor', 'texto', 'loading']
  }
</script>



// WEBPACK FOOTER //
// src/components/QuadroMoeda.vue